import { getuuid } from "../uuid";
import JSEncrypt from "jsencrypt";
import { getLPK } from "./fetchWasm";
import { dateCalibration, serverDate } from "./dateCalibration";

const K = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxJ5ARicPBuuJ57o/bk51
ybz3DKFBxcw3Go6S9kWTZofSYcvjDuGtZzMZzW+vgwBp/a3Ip8H8W+a/8rBulxNt
cCOk/i6K5aKMpeQAslN+2rE8rFwMlOasPXvGqOpJVLLMk6uBNaqtxq90loYHYhAE`;

const getSign = async url => {
  const signer = new JSEncrypt();
  const KK = K + "\n" + (await getLPK());
  signer.setPublicKey(KK);
  const a = getuuid(6, 36);
  const p = getuuid(6, 36);
  const u = getuuid(6, 36);
  const timesTamp = (await serverDate()) + "";
  const DAY = dateCalibration(timesTamp, "day");
  const MONTH = dateCalibration(timesTamp, "month");
  // 保留星期/月截取规则，后段不能超过星期截取后剩余的时间戳长度。
  const lastLen = Math.min(MONTH, timesTamp.length - DAY);
  const signPath = url.replace(/^(?:https?:)?\/\/[^/?#]+/i, "").split(/[?#]/)[0] || "/";
  const ttapList = [timesTamp.slice(0, DAY), timesTamp.slice(DAY)];
  const midTimesTamp = ttapList[0] + p + ttapList[1];
  const midttapList = lastLen !== 0 ? [midTimesTamp.slice(0, -lastLen), midTimesTamp.slice(-lastLen)] : [midTimesTamp, ""];
  const S = midttapList[0] + signPath + midttapList[1];
  const si = signer.encrypt(S);
  if (!si) throw new Error("请求签名生成失败，请重试");

  return {
    si,
    a,
    p,
    u
  };
};

export { getSign };
